<div
	class="image-card-outer-wrapper"
	[class.card--selected]="isSelected()"
	[attr.data-testid]="effectiveTestId()"
	(click)="onCardClick()"
>
	@if (isDebugMode()) {
		<div
			class="debug-info"
			style="
				position: absolute;
				top: 4px;
				left: 4px;
				z-index: 100;
				background: rgba(0, 0, 0, 0.75);
				color: #fff;
				padding: 4px 8px;
				font-size: 10px;
				font-family: 'SF Mono', Monaco, monospace;
				border-radius: 4px;
				backdrop-filter: blur(4px);
				display: flex;
				gap: 8px;
				align-items: center;
			"
		>
			<span style="color: #4fc3f7">{{ cardId() }}</span>
			<span
				style="
					background: #009688;
					padding: 1px 6px;
					border-radius: 3px;
					font-size: 9px;
					text-transform: uppercase;
				"
				>image</span
			>
		</div>
	}

	@if (isLoading()) {
		<div class="image-card-loader">
			<jepto-ui-progress-bar-indeterminate />
		</div>
	}

	@if (effectiveTitle() || effectiveSubtitle() || effectiveIcon()) {
		<div class="card-header">
			<div class="card-icon-title-wrapper">
				@if (effectiveIcon()) {
					<mat-icon class="material-symbols-outlined card-icon">{{
						effectiveIcon()
					}}</mat-icon>
				}
				@if (effectiveTitle()) {
					<h2 class="card-title">{{ effectiveTitle() }}</h2>
				}
			</div>
			@if (effectiveSubtitle()) {
				<div class="card-subtitle">{{ effectiveSubtitle() }}</div>
			}
		</div>
	}

	@if (!isLoading() && effectiveImageUrl()) {
		<div class="image-content">
			<img
				[src]="effectiveImageUrl()"
				[alt]="effectiveAlt()"
				class="image-card-img"
				[style]="imageStyles()"
			/>
		</div>
	}

	@if (hasNoImage()) {
		<div class="empty-state">
			<span>No image available</span>
		</div>
	}

	@if (isSelected()) {
		<div class="card-action-buttons">
			<button
				type="button"
				class="card-action-btn"
				aria-label="Edit card"
				(click)="editCard.emit()"
			>
				<span class="icon-edit-2"></span>
			</button>
			<button
				type="button"
				class="card-action-btn"
				aria-label="More options"
				[matMenuTriggerFor]="cardMenu"
				(click)="$event.stopPropagation()"
			>
				<span class="icon-more-vertical"></span>
			</button>
		</div>

		<mat-menu #cardMenu="matMenu" panelClass="card-actions-menu">
			<button mat-menu-item (click)="editCard.emit()">Edit</button>
			<button mat-menu-item (click)="duplicateCard.emit()">
				Duplicate
			</button>
			<button mat-menu-item disabled type="button">Save card</button>
			<button
				mat-menu-item
				class="card-menu-item--danger"
				(click)="deleteCard.emit()"
			>
				Delete
			</button>
		</mat-menu>
	}
</div>
